/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 二维码刷新
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  orderDetailId: string,
  orderId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.TicketItemRepository;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/ticket-folder/refresh/${orderId}/${orderDetailId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
